import React from "react";
import { UseFormRegister } from "react-hook-form";
import Input from "../Input/Input";

type CertificateAreaFieldProps = {
  label: string;
  name: string;
  /**
   * Typed against react-hook-form's own UseFormRegister<any> rather than a
   * hand-rolled function signature, since LevelOnePaymentConfirm.tsx,
   * LevelTwoPaymentConfirm.tsx and LevelThreePaymentApproval.tsx each infer
   * a different, strict field-name union type from their own useForm() call
   * - a plain `(name: string) => any` type isn't assignable to that.
   */
  register: UseFormRegister<any>;
  required?: boolean;
};

/**
 * The certificate form itself is duplicated across L1, L2 and L3, each with
 * its own ~1000-line file and no shared field components, so refactoring
 * every existing field wasn't in scope here. This component exists so that
 * the one new field this session actually needs - Deduction in Plot Area -
 * only has to be defined once and then dropped into all three forms, rather
 * than becoming a fourth hand-copied block that can drift out of sync the
 * same way the certificate save/read logic already has.
 */
export function CertificateAreaField({
  label,
  name,
  register,
  required,
}: CertificateAreaFieldProps) {
  return (
    <div className="col-span-2 md:col-span-1">
      <Input
        required={required}
        type="number"
        onWheel={(e: React.WheelEvent<HTMLInputElement>) => {
          e.currentTarget.blur();
          e.stopPropagation();
          setTimeout(() => {
            e.currentTarget.focus();
          }, 0);
        }}
        label={label}
        placeholder={label}
        {...register(name, { valueAsNumber: true })}
      />
    </div>
  );
}
